class DocumentCaptureError extends Error {
  public title: string;

  public static defaultErrorMessage = 'We are experiencing technical difficulties, please try again';

  constructor(message: string, title: string = 'Document Capture Error') {
    super(message);
    this.name = 'DocumentCaptureError';
    this.title = title;

    // This line is needed to fix the stack trace (which is off by default)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, DocumentCaptureError);
    }
  }

  public static getErrorMessage(e: unknown) {
    if (typeof e === 'object' && e && 'error' in e) {
      const { error: rawError } = e as { error: string };
      if (rawError === '') {
        return this.defaultErrorMessage;
      }

      try {
        const parsedErrorMessage = JSON.parse(rawError);
        if (parsedErrorMessage && 'message' in parsedErrorMessage) {
          return parsedErrorMessage.message;
        }
      } catch (parseError) {
        return rawError;
      }
    }
    return this.defaultErrorMessage;
  }
}

export {
  DocumentCaptureError,
};
